module.exports = __webpack_public_path__ + "img/limitless-icon.6f387ff6.svg";